import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appFormGrid]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppFormGridDirective {
  class = input<string>();
  cols = input<string | number>('1');

  #base = 'grid grid-cols-1 gap-4';

  public styles = computed(() => {
    return cn(
      this.#base,
      {
        'md:!grid-cols-2': this.cols().toString() === '2',
      },
      this.class(),
    );
  });
}
